import { MenuTypes } from '@zeptonow/zui/Menu';
import { FilterRoutesInterface } from './types';

export const findNode = (
  key: keyof MenuTypes,
  currentRoute: string,
  routes: MenuTypes[],
): MenuTypes | undefined => {
  for (const node of routes) {
    if (node[key]) {
      const parts = (node[key] as string).split(':'); // Split the string by ':'
      const base = parts[0]; // First part (e.g., "job-requisitions")
      const segmentCount = parts.length - 2; // Count the number of segments after the first part
      // const currentRouteParts = currentRoute.split('/'); // Split the current route by '/'

      const pattern = new RegExp(
        '^' +
          base +
          '([^/]+)/'.repeat(segmentCount > 0 ? segmentCount : 0) +
          '([^/]+)$',
      );

      if (
        currentRoute.includes((node[key] as string).split(':')[0]) &&
        pattern.test(node[key] as string)
      )
        return node;
      if (node[key] === currentRoute) return node;
      if (node.children) {
        const child = findNode(key, currentRoute, node.children);
        if (child) return child;
      }
    }
  }
  return undefined;
};

export const filterRoutes: FilterRoutesInterface = ({ routes }) => {
  if (!routes || !routes.length) return undefined;
  return routes
    .filter((route) => !route.breadcrumbsExclusion)
    .map((route) => ({
      ...route,
      component: route.component || null,
      children: filterRoutes({
        routes: route.children,
      }),
    }));
};
